<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";
import Style from "@/views/layouts/style";
import DontExist from "@/components/company/components/DontExist"
import puntuationAPI from "@/services/standards/puntuation/puntuationAPI";
import CheckModal from "../../../../components/CheckModal.vue";
import PModal from "../../../../components/pModal.vue";
import HModal from "../../../../components/hModal.vue";
import VModal from "../../../../components/vModal.vue";
import AModal from "../../../../components/aModal.vue";


/**
 * Form elements component
*/
export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Style,
    DontExist,
    CheckModal,
    PModal,
    HModal,
    VModal,
    AModal,
  },
  data() {
    return {
      title: "Ciclo de mejora continua PHVA",

      loading: true,
      items: [],
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      companies_id: this.$store.getters["company/getCompany"].id || null,

    };
  },
  computed: {},

  methods: {
    getList() {
      puntuationAPI.getpuntuation(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {

          let identification = response.data;
          this.lista = identification
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);

        });
    },

    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },
  },

  mounted() {
    this.getList()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading && classificationID <= 4">

          <div class="row">
            <div class="col-12">
              <div class="card">

                <div class="row">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <div class="form-row row text-center">
                            <form class="form-inline">



                            </form>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-group text-right m-b-0">

                          </div>
                        </div>
                      </div>

                      <div class="table-responsive phva-flow">

                        <table class="
                            pt-2
                            table
                            border-bottom
                            divide-y divide-gray-200
                            table-striped
                            rounded
                          ">
                          <thead>
                            <!--   <tr>

                              <th class="text-center align-middle">
                                <h4>PHVA</h4>
                              </th>

                            </tr> -->
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr>
                              <td class="text-center align-middle ">
                                <div class="card text-white border-primary bg-white mb-3 card-spacer-y: shadow-lg"
                                  style="width: 13rem;">

                                  <div class="card-body ">
                                    <h5 class="card-title">Planear</h5>
                                    <div>
                                      <h3>
                                        <button v-b-modal.modal-p
                                          class="btn btn-primary">
                                          P
                                        </button>
                                      </h3>
                                      <b-modal id="modal-p" size="lg" title="P" title-class="font-18" hide-footer>
                                        <p class="text-justify">
                                          <b>Planear:</b>
                                        </p>
                                        <p class="text-justify">
                                        <ul>
                                          <li>
                                            1.1.1 Responsable del SG SST
                                          </li>
                                          <li>
                                            1.1.2 Responsabilidades en el SG SST
                                          </li>
                                          <li>
                                            1.1.3. Asignación de Recursos para el SG SST
                                          </li>
                                          <li>
                                            1.1.4 Afiliación al Sistema General de Riesgos Laborales
                                          </li>
                                          <li>
                                            1.1.5 Pago de Pensión Trabajadores de Alto Riesgo
                                          </li>
                                          <li>
                                            1.1.6 Conformación del Copasst
                                          </li>
                                          <li>
                                            1.1.7 Capacitación del Copasst
                                          </li>
                                          <li>
                                            1.1.8 Conformación Comité Convivencia
                                          </li>
                                          <li>
                                            1.2.1 Programa Capacitación Promoción y Prevención - P y P
                                          </li>
                                          <li>
                                            1.2.2 Capacitación, Inducción y Reinducción en SG SST
                                          </li>
                                          <li>
                                            1.2.3 Responsable del SG SST - Curso 50 Horas
                                          </li>
                                          <li>
                                            2.1.1 Politica del SG SST - Firmada Fechada y Divulgada al Copasst y los
                                            colaboradores
                                          </li>
                                          <li>
                                            2.2.1 Objetivos definidos, claros, medibles, cuantificables, con metas,
                                            documentos, revisados del SG SST
                                          </li>
                                          <li>
                                            2.3.1 Evaluación e identificación de Prioridades
                                          </li>
                                          <li>
                                            2.4.1 Plan que identifica objetivos, metas, responsabilidad, recursos con
                                            cronograma y firmado
                                          </li>
                                          <li>
                                            2.5.1 Archivo o Retención documental del SG SST
                                          </li>
                                          <li>
                                            2.6.1 Rendición sobre el desempeño
                                          </li>
                                          <li>
                                            2.7.1 Matriz Legal
                                          </li>
                                          <li>
                                            2.8.1 Mecanismo de comunicación, auto reporte del SG SST
                                          </li>
                                          <li>
                                            2.9.1 Identificación, Evaluación para adquisición de productos y servicios
                                            en
                                            el SG SST
                                          </li>
                                          <li>
                                            2.10.1 Evaluación y selección de proveedores y contratista
                                          </li>
                                          <li>
                                            2.11.1 Evaluación del impacto de cambios internos y externos en el SG SST
                                          </li>
                                          <li>
                                            2.6.1 Rendición sobre el desempeño
                                          </li>
                                        </ul>
                                        </p>
                                      </b-modal>
                                    </div>


                                  </div>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <i class="mdi-arrow-right-bold mdi mdi-48px"></i>
                                </div>
                                <div>
                                  <i class="mdi-arrow-left-bold mdi mdi-48px"></i>
                                </div>
                              </td>
                              <td class="text-center align-middle">
                                <div class="card text-white border-primary bg-white mb-3 card-spacer-y: shadow-lg"
                                  style="width: 13rem;">

                                  <div class="card-body">
                                    <h5 class="card-title">Hacer</h5>
                                    <div>
                                      <h3>
                                        <button v-b-modal.modal-h class="btn btn-primary">
                                          H
                                        </button>
                                      </h3>
                                      <b-modal id="modal-h" size="lg" title="H" title-class="font-18" hide-footer>
                                        <p class="text-justify">
                                          <b>Hacer:</b>
                                        </p>
                                        <p class="text-justify">
                                        <ul>
                                          <li>
                                            3.1.1 Evaluación Medica Ocupacional

                                          </li>
                                          <li>
                                            3.1.2 Actividades de Promoción y Prevención en Salud

                                          </li>
                                          <li>
                                            3.1.3 Informar al médico los perfiles de cargo

                                          </li>
                                          <li>
                                            3.1.4 Realización de los exámenes médicos ocupacionales - Peligros -
                                            Periodicidad

                                          </li>
                                          <li>
                                            3.1.5 Custodia de Historias Clínica

                                          </li>
                                          <li>
                                            3.1.6 Restricciones y Recomendaciones Laborales

                                          </li>
                                          <li>
                                            3.1.7 Estilo de vida y entornos saludables (Controles tabaquismo,
                                            alcoholismo, farmaco dependiencia y otros)

                                          </li>
                                          <li>
                                            3.1.8 Agua Potable, Servicios Sanitarios, Disposición de Basura

                                          </li>
                                          <li>
                                            3.1.9 Eliminación adecuada de residuos sólidos, líquidos o gaseosos

                                          </li>
                                          <li>
                                            3.2.1 Reporte de los Accidentes de Trabajo y enfermedad Laboral

                                          </li>
                                          <li>
                                            3.2.2 Investigación de Accidentes de Trabajo y enfermedad Laboral

                                          </li>
                                          <li>
                                            3.2.3 Registro y análisis estádistico de Incidentes, Accidentes de Trabajo y
                                            Enfermedad Laboral

                                          </li>
                                          <li>
                                            3.3.1 Medición de la severidad de los AT y EL

                                          </li>
                                          <li>
                                            3.3.2 Medición de la frecuencia de los incidentes, Accidentes de Trabajo y
                                            Enfermedad Laboral

                                          </li>
                                          <li>
                                            3.3.3 Medición de la Mortalidad de los AT y EL

                                          </li>
                                          <li>
                                            3.3.4 Medición de la prevalencia de la enfermedad laboral

                                          </li>
                                          <li>
                                            3.3.5 Medición de la incidencia.de la Enfermedad Laboral

                                          </li>
                                          <li>
                                            3.3.6 Medición del ausentismo por causa médica

                                          </li>
                                          <li>
                                            4.1.1 Metodología para la identificación, evaluación y valoración de
                                            peligros

                                          </li>
                                          <li>
                                            4.1.2 Identificación de peligros con participación de todos los niveles de
                                            la organización

                                          </li>
                                          <li>
                                            4.1.3 Identificación y priorización de la naturaleza de los peligros
                                            (Metodología adicional, cancerígenos y otros)

                                          </li>
                                          <li>
                                            4.1.4 Realización mediciones ambientales, químicos, físicos y biológicos

                                          </li>
                                          <li>
                                            4.2.1 Se implementan medidas de prevención y control / peligros

                                          </li>
                                          <li>
                                            4.2.2 Se verifica aplicación de las medidas prevención y control

                                          </li>
                                          <li>
                                            4.2.3 Hay procedimientos, instructivos, fichas, protocolos

                                          </li>
                                          <li>
                                            4.2.4 Inspección con el COPASST o Vigia

                                          </li>
                                          <li>
                                            4.2.5 Mantenimiento periódico de instalaciones, equipos, máquinas,
                                            herramientas.


                                          </li>
                                          <li>
                                            4.2.6 Entrega de Elementos de Protección Personal - EPP, se verifica con
                                            contratista y subcontratistas

                                          </li>
                                          <li>
                                            5.1.1 Se cuenta con el Plan de Prevención y Prevención ante Emergencias

                                          </li>
                                          <li>
                                            5.1.2 Brigada de prevención, conformada y dotada
                                          </li>
                                        </ul>
                                        </p>
                                      </b-modal>
                                    </div>


                                  </div>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <i class="mdi-arrow-right-bold mdi mdi-48px"></i>
                                </div>
                                <div>
                                  <i class="mdi-arrow-left-bold mdi mdi-48px"></i>
                                </div>
                              </td>
                              <td class="text-center align-middle">
                                <div class="card text-white border-primary bg-white mb-3 card-spacer-y: shadow-lg"
                                  style="width: 13rem;">

                                  <div class="card-body">
                                    <h5 class="card-title">Verificar</h5>
                                    <div>
                                      <h3>
                                        <button v-b-modal.modal-v class="btn btn-primary">
                                          V
                                        </button>
                                      </h3>
                                      <b-modal id="modal-v" size="lg" title="V" title-class="font-18" hide-footer>
                                        <p class="text-justify">
                                          <b>Verificar:</b>
                                        </p>
                                        <p class="text-justify">
                                        <ul>
                                          <li>

                                            6.1.1 Indicadores de Estructura, Proceso y Resultado

                                          </li>
                                          <li>
                                            6.1.2 La Empresa realiza auditoría por lo menos una vez al año

                                          </li>
                                          <li>
                                            6.1.3 Revisión anual por la Alta Dirección, resultados y alcance de la
                                            auditoría

                                          </li>
                                          <li>
                                            6.1.4 Planificación Auditorías con el COPASST
                                          </li>
                                        </ul>
                                        </p>
                                      </b-modal>
                                    </div>


                                  </div>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <i class="mdi-arrow-right-bold mdi mdi-48px"></i>
                                </div>
                                <div>
                                  <i class="mdi-arrow-left-bold mdi mdi-48px"></i>
                                </div>
                              </td>
                              <td class="text-center align-middle">
                                <div class="card text-white border-primary bg-white mb-3 card-spacer-y: shadow-lg"
                                  style="width: 13rem;">

                                  <div class="card-body">
                                    <h5 class="card-title">Actuar</h5>

                                    <div>
                                      <h3>
                                        <button v-b-modal.modal-a class="btn btn-primary">
                                          A
                                        </button>
                                      </h3>
                                      <b-modal id="modal-a" size="lg" title="A" title-class="font-18" hide-footer>
                                        <p class="text-justify">
                                          <b>Actuar:</b>
                                        </p>
                                        <p class="text-justify">
                                        <ul>
                                          <li>

                                            7.1.1 Definir acciones de Promoción y Prevención con base en resultados del
                                            SG SST

                                          </li>
                                          <li>
                                            7.1.2 Toma de Medidas Correctivas, Preventivas y De Mejora

                                          </li>
                                          <li>
                                            7.1.3 Ejecución de Acciones Correctivas, Preventivas y De Mejora de la
                                            Investigación de Incidentes, Accidentes de Trabajo y Enfermedad Laboral

                                          </li>
                                          <li>
                                            7.1.4 Implementar medidas y acciones correctivas de autoridades y ARL
                                          </li>
                                        </ul>
                                        </p>
                                      </b-modal>
                                    </div>


                                  </div>
                                </div>
                              </td>

                            </tr>


                          </tbody>
                        </table>

                        <div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- end col -->
                </div>


              </div>
            </div>


          </div>
        </div>

        <div v-else-if="!loading && classificationID > 3">
          <DontExist />
        </div>

        <div v-else-if="!loading">
          <DontExist />
        </div>
        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
// El diagrama P-H-V-A con tarjetas de 13rem fijas ya no cabe junto al riel (1078 px de contenido):
// las tarjetas se encogen hasta 11rem para que "Actuar" no quede cortada (Q-008).
.phva-flow .card {
  width: auto !important;
  min-width: 11rem;
  max-width: 13rem;
  margin-left: auto;
  margin-right: auto;
}
</style>
